<template>
    <nav class="tyn-appbar">
        <div class="tyn-appbar-wrap">
            <div class="tyn-appbar-logo">
                <router-link class="tyn-logo" :to="{ name: 'Home' }" @click.native="onLogoClick">
                    <template v-if="instituicao && instituicao.urlImagemSistemaS3">
                        <img class="img-responsive logo-home" :src="instituicao.urlImagemSistemaS3" alt="Logo da instituição" />
                        <img class="img-responsive logo-home-white" :src="instituicao.urlImagemSistemaS3" alt="Logo da instituição" />
                    </template>
                    <template v-else>
                        <img class="img-responsive logo-home" src="/assets/images/sollai/logo.png">
                        <img class="img-responsive logo-home-white" src="/assets/images/sollai/logo_white.png">
                    </template>
                </router-link>
            </div>
            <div class="tyn-appbar-content">
                <!-- NAVEGACAO -->
                <ul class="tyn-appbar-nav tyn-appbar-nav-start">
                    <template v-for="(item,index) in lstLink" >
                        <li :class="'tyn-appbar-item d-none d-sm-inline-flex ' +(subIsActive(item)?' active current-page':'')" v-if="item.flPossuiProduto" :key="index">
                                <router-link :to="item.to" class="tyn-appbar-link" data-bs-custom-class="custom-popover" data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" :data-bs-content="item.name">
                                    <template v-if="item.img">
                                        <img class="img-icone" :class="(item.class?item.class:'')" :src="item.img" :alt="item.name">
                                    </template>
                                    <template v-if="item.icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="currentColor" class="bi bi-database-up" viewBox="0 0 16 16" v-html="item.icon" style="height:32px; width: 30px; ">
                                        </svg>
                                    </template>
                                    <span class="d-none">{{item.name}}</span>
                                </router-link>
                        </li>
                    </template>
                    
                </ul>

                <ul class="tyn-appbar-nav tyn-appbar-nav-center">

                    <li v-if="msgPreparandoAmbiente">

                        <p class="mb-0 txt-p msg-ambiente-warning  d-none d-lg-block fs-6" v-if="msgPreparandoAmbiente == 'creating'">
                            <i class="fas fa-spinner fa-spin"></i> Estamos configurando seu ambiente personalizado. Em instantes você poderá interagir normalmente.
                        </p>

                        <p class="mb-0 msg-ambiente-danger  txt-p d-none d-lg-block fs-6" v-if="msgPreparandoAmbiente == 'error'">
                            <i class="fas fa-exclamation-triangle"></i> Ocorreu um erro na configuração do seu ambiente personalizado. Entre em contato com o administrador.
                        </p>
                    </li>
                    <li v-if="msgManutencao">
                        <p class="mb-0 txt-p msg-manutencao d-none d-lg-block fs-6">
                            Olá! Aqui é Sollai, a 1ª IA especialista em licitações e contratos do Brasil. Estou passando por uma atualização e treinamento em minha base, o que pode causar algumas oscilações em meu desempenho. Agradeço pela sua compreensão e estou trabalhando para retornar ao meu melhor estado o mais breve possível.
                        </p>
                    </li>
                    <li v-if="alertaContratoExpirando">
                        <p class="mb-0 txt-p msg-contrato-expirando d-none d-lg-block fs-6">
                            <i class="fas fa-exclamation-circle me-1"></i>
                            {{ mensagemContratoExpirando }}
                        </p>
                    </li>
                </ul>

                <ul class="tyn-appbar-nav tyn-appbar-nav-end">
                    <!-- Quick Links -->
                    <QuickLinks :lstLink="lstLink"></QuickLinks>

                    <!-- NOTIFICACOES -->
                    <NotificacoesHeader></NotificacoesHeader>

                    <li class="tyn-appbar-item" v-if="user">
                        <a class="d-inline-flex dropdown-toggle" data-bs-auto-close="outside" data-bs-toggle="dropdown" href="#" data-bs-offset="0,10">
                            <div class="tyn-media tyn-size-lg tyn-circle">
                                <template v-if="user.usuarioApi">
                                    <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                    <img v-else src="/assets/images/avatar/3.jpg" alt="">
                                </template>
                                <template v-else>
                                    <img src="/assets/images/avatar/3.jpg" alt="">
                                </template>
                            </div>
                        </a><!-- .dropdown-toggle -->
                        <div class="dropdown-menu dropdown-menu-end">
                            <div class="dropdown-gap">
                                <div class="tyn-media-group">
                                    <div class="tyn-media tyn-size-lg">
                                        <template v-if="user.usuarioApi">
                                            <img v-if="user.usuarioApi.urlImgFoto" :src="user.usuarioApi.urlImgFoto" alt="" />
                                            <img v-else src="/assets/images/avatar/3.jpg" alt="">
                                        </template>
                                        <template v-else>
                                            <img src="/assets/images/avatar/3.jpg" alt="">
                                        </template>
                                    </div>
                                    <div class="tyn-media-col">
                                        <div class="tyn-media-row">
                                            <h6 class="name">{{primeiroNome}}</h6>
                                            <div class="indicator varified">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle-fill" viewBox="0 0 16 16">
                                                    <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0m-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z" />
                                                </svg><!-- check-circle-fill -->
                                            </div>
                                        </div>
                                        <div class="tyn-media-row has-dot-sap">
                                            <p class="content">{{user.usuario.dsEmail}}</p>
                                        </div>
                                    </div><!-- .tyn-media-col -->
                                </div><!-- .tyn-media-group -->
                            </div><!-- .dropdown-gap -->
                            <div class="dropdown-gap">
                                <div class="d-flex gap gap-2">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-moon-fill" viewBox="0 0 16 16">
                                        <path d="M6 .278a.77.77 0 0 1 .08.858 7.2 7.2 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277q.792-.001 1.533-.16a.79.79 0 0 1 .81.316.73.73 0 0 1-.031.893A8.35 8.35 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.75.75 0 0 1 6 .278" />
                                    </svg><!-- moon-fill -->
                                    <div>
                                        <h6>Tema escuro</h6>
                                    </div>
                                    <div class="form-check form-check-reverse form-switch">
                                        <input class="form-check-input" v-model="theme" type="checkbox" role="switch" id="theme">
                                    </div>
                                </div>
                            </div>
                            <ul class="tyn-list-links">
                                <li>
                                    <a href="javascript:void(0)" @click="showModal(showModalDados,'ModalDados')">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person" viewBox="0 0 16 16">
                                            <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m2-3a2 2 0 1 1-4 0 2 2 0 0 1 4 0m4 8c0 1-1 1-1 1H3s-1 0-1-1 1-4 6-4 6 3 6 4m-1-.004c-.001-.246-.154-.986-.832-1.664C11.516 10.68 10.289 10 8 10s-3.516.68-4.168 1.332c-.678.678-.83 1.418-.832 1.664z" />
                                        </svg><!-- person -->
                                        <span>Dados</span>
                                    </a>
                                </li>
                                <li v-if="(isAdmContrato == 'Sim' || user.usuario.idContrato == 0 || user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br')">
                                    <a href="javascript:void(0)" @click="showModal(showModalDadosInstituicao,'DadosInstituicao')">
                                        <i class="fas fa-id-card"></i>
                                        <span>Dados da Instituição</span>
                                    </a>
                                </li>
                                <li v-if="!isEmailContato">
                                    <a href="javascript:void(0)" @click="showModal(showModalSenha,'ModalSenha')">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-unlock" viewBox="0 0 16 16">
                                            <path d="M11 1a2 2 0 0 0-2 2v4a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h5V3a3 3 0 0 1 6 0v4a.5.5 0 0 1-1 0V3a2 2 0 0 0-2-2M3 8a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z" />
                                        </svg>
                                        <span>Mudar senha</span>
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript:void(0)" @click="showModal(showModalMetodo,'ModalMetodo')">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-book" viewBox="0 0 16 16">
                                            <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
                                        </svg>
                                        <span>Método de trabalho</span>
                                    </a>
                                </li>
                                <!--<li>
        <a href="javascript:void(0)" @click="showModal(showManualUsuario,'ManualUsuario')">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-book" viewBox="0 0 16 16">
                <path d="M1 2.828c.885-.37 2.154-.769 3.388-.893 1.33-.134 2.458.063 3.112.752v9.746c-.935-.53-2.12-.603-3.213-.493-1.18.12-2.37.461-3.287.811zm7.5-.141c.654-.689 1.782-.886 3.112-.752 1.234.124 2.503.523 3.388.893v9.923c-.918-.35-2.107-.692-3.287-.81-1.094-.111-2.278-.039-3.213.492zM8 1.783C7.015.936 5.587.81 4.287.94c-1.514.153-3.042.672-3.994 1.105A.5.5 0 0 0 0 2.5v11a.5.5 0 0 0 .707.455c.882-.4 2.303-.881 3.68-1.02 1.409-.142 2.59.087 3.223.877a.5.5 0 0 0 .78 0c.633-.79 1.814-1.019 3.222-.877 1.378.139 2.8.62 3.681 1.02A.5.5 0 0 0 16 13.5v-11a.5.5 0 0 0-.293-.455c-.952-.433-2.48-.952-3.994-1.105C10.413.809 8.985.936 8 1.783" />
            </svg>
            <span>Manual do Usuário</span>
        </a>
    </li>-->
                                <li v-if="isAdmOuInterno">
                                    <router-link :to="'/GerenciarUsuarios'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-lines-fill" viewBox="0 0 16 16">
                                            <path d="M6 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6m-5 6s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zM11 3.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5m.5 2.5a.5.5 0 0 0 0 1h4a.5.5 0 0 0 0-1zm2 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1zm0 3a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1z" />
                                        </svg>
                                        <span>Gerenciar Usuários</span>
                                    </router-link>
                                </li>
                                <li class="d-none">
                                    <router-link :to="'/Relatorios'">
                                        <i class="fas fa-chart-bar"></i>
                                        <span>Relatórios</span>
                                    </router-link>
                                </li>
                                <li v-if="isAdmContrato == 'Sim'">
                                    <router-link :to="'/TipoEnvolvidoAssinatura'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 24 24">
                                            <path d="M22,22H2V20H22V22M6.2,17.3L5.5,18L4.1,16.6L2.7,18L2,17.3L3.4,15.9L2,14.5L2.7,13.8L4.1,15.2L5.5,13.8L6.2,14.5L4.8,15.9L6.2,17.3M16.22,14.43C16.22,13.85 15.5,13.2 14.06,12.46C12.23,11.54 11,10.79 10.36,10.24C9.71,9.68 9.39,9.06 9.39,8.37C9.39,6.59 10.3,5.12 12.12,3.95C13.94,2.78 15.43,2.19 16.57,2.19C17.31,2.19 17.85,2.32 18.18,2.58C18.5,2.83 18.68,3.27 18.68,3.9C18.68,4.18 18.56,4.42 18.31,4.63C18.07,4.83 17.87,4.93 17.74,4.93C17.63,4.93 17.43,4.83 17.13,4.64L16.55,4.38C16.08,4.38 15.14,4.71 13.71,5.38C12.29,6.04 11.58,6.79 11.58,7.63C11.58,8.14 11.82,8.6 12.32,9C12.82,9.42 13.71,9.93 15,10.53C16.03,11 16.86,11.5 17.5,12.07C18.1,12.61 18.41,13.25 18.41,14C18.41,15.34 17.47,16.41 15.58,17.17C13.7,17.94 11.9,18.32 10.19,18.32C8.75,18.32 8,17.83 8,16.86C8,16.5 8.19,16.27 8.5,16.11C8.83,15.95 9.16,15.87 9.5,15.87L10.25,16L10.97,16.13C11.95,16.13 13,15.97 14.13,15.64C15.26,15.32 15.96,14.91 16.22,14.43Z" />
                                        </svg>
                                        <span>Gerenciar Envolvidos em Assinaturas</span>
                                    </router-link>
                                </li>
                                <li v-if="isAdmOuInterno">
                                    <router-link :to="'/GerenciarUnidadeSetor'">
                                        <i class="fas fa-building"></i>
                                        <span>Gerenciar Unidade/Setor</span>
                                    </router-link>
                                </li>
                                <li v-if="isAdmOuInterno">
                                    <router-link :to="'/RelatorioUso'">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-bar-graph" viewBox="0 0 16 16">
                                            <path d="M10 13.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-6a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5zm-2.5.5a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5zm-3 0a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5z" />
                                            <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                        </svg>
                                        <span>Relatório de Uso</span>
                                    </router-link>
                                </li>
                                <template v-if="false">
                                    <!--<li v-if="isAdmContrato == 'Sim' || user.usuario.idContrato == 0">-->
                                    <!--v-if="isAdmContrato == 'Sim'"-->
                                    <!--<a href="javascript:void(0)" @click="acao('RelatorioAcesso')">
                    <i class="feather-file-text"></i>
                    <span>Relatório de Acesso</span>
                </a>
        </li>-->
                                    <li v-if="isAdmContrato == 'Sim' || user.usuario.idContrato == 0 || user.usuario.dsLogin == 'aline.oliveira@negociospublicos.com.br'">
                                        <a href="javascript:void(0)" @click="showModal(showModalNormativa,'ModalNormativa')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-arrow-up" viewBox="0 0 16 16">
                                                <path d="M8.5 11.5a.5.5 0 0 1-1 0V7.707L6.354 8.854a.5.5 0 1 1-.708-.708l2-2a.5.5 0 0 1 .708 0l2 2a.5.5 0 0 1-.708.708L8.5 7.707z" />
                                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2M9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z" />
                                            </svg>
                                            <span>Normativa</span>
                                        </a>
                                    </li>
                                </template>

                                <!-- SUPORTE  -->
                                <template v-if="user.usuario.tpPessoa == 'J' && user.usuario.flCortesia != 'Sim'">
                                    <template v-if="user.usuario.idContrato != null && user.usuario.idPessoa != null">
                                        <li class="dropdown-divider"></li>
                                        <li>
                                            <a :href="urlSuporte+'p_idContrato='+user.usuario.idContrato+'&amp;p_idPessoa='+user.usuario.idPessoa" target="_blank">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward-fill" viewBox="0 0 16 16">
                                                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708"></path>
                                                </svg>
                                                <span>Falar com o suporte</span>
                                            </a>
                                        </li>
                                    </template>
                                </template>

                                <li class="dropdown-divider"></li>

                                <li>
                                    <a href="javascript:void(0)" @click="sair">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-power" viewBox="0 0 16 16">
                                            <path d="M7.5 1v7h1V1z" />
                                            <path d="M3 8.812a5 5 0 0 1 2.578-4.375l-.485-.874A6 6 0 1 0 11 3.616l-.501.865A5 5 0 1 1 3 8.812" />
                                        </svg><!-- power -->
                                        <span>Sair</span>
                                    </a>
                                </li>
                            </ul><!-- .tyn-list-links -->
                        </div><!-- .dropdown-menu -->
                    </li><!-- .tyn-appbar-item -->
                </ul><!-- .tyn-appbar-nav -->
            </div><!-- .tyn-appbar-content -->
        </div><!-- .tyn-appbar-wrap -->
    </nav><!-- .tyn-appbar -->
</template>

<script>
    import QuickLinks from '@/components/QuickLinks'
    import NotificacoesHeader from '@/components/NotificacoesHeader'

    import { urlApi, avisoErro, msgManutencao, urlSuporte } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Header',
        components: { QuickLinks, NotificacoesHeader },
        computed: {
            showModalSenha() {
                return this.$store.state.showModalSenha
            },
            showModalDados() {
                return this.$store.state.showModalDados
            },
            showModalDadosInstituicao() {
                return this.$store.state.showModalDadosInstituicao
            },
            showModalMetodo() {
                return this.$store.state.showModalMetodo
            },
            showModalNormativa() {
                return this.$store.state.showModalNormativa
            },
            showManualUsuario() {
                return this.$store.state.showManualUsuario
            },
            user() {
                return this.$store.state.user
            },
            instituicao() {
                return this.$store.state.instituicao
            },

            isAdmContrato() {
                return this.$store.state.isAdmContrato
            },
            isContratoZero() {
                return this.user.usuario.idContrato === 0;
            },
            isAdmOuInterno() {
                return this.isAdmContrato == 'Sim' || this.isContratoZero || this.user?.usuarioApi?.flAdministrador;
            },

            tpPessoa() {
                return this.$store.state.tpPessoa
            },

            primeiroNome() {
                if (this.user && this.user.usuario) {
                    if (this.user.usuarioApi) {
                        return this.user.usuarioApi.nmUsuario.split(" ")[0]
                    } else {
                        if (this.user.usuario.nmUsuario) {
                            return this.user.usuario.nmUsuario.split(" ")[0]
                        } else {
                            return "";
                        }
                    }
                } else {
                    return "";
                }
            },

            isEmailContato() {
                const u = this.user;
                const email =
                    (u && u.usuario && u.usuario.dsEmail) ? u.usuario.dsEmail :
                        (u && u.usuarioApi && u.usuarioApi.dsEmail) ? u.usuarioApi.dsEmail :
                            '';
                return String(email).trim().toLowerCase() === 'contato@sollai.com.br';
            },


            hubConection() {
                return this.$store.state.hubConection
            },

            diasRestantesContrato() {
                const dtFim = this.$store.state.dtFimContrato;
                if (!dtFim) return null;

                const fim = new Date(dtFim);
                if (Number.isNaN(fim.getTime())) return null;

                const hoje = new Date();
                hoje.setHours(0, 0, 0, 0);
                fim.setHours(0, 0, 0, 0);

                return Math.ceil((fim - hoje) / (1000 * 60 * 60 * 24));
            },

            alertaContratoExpirando() {
                if (!this.user?.usuario) return false;
                if (this.user.usuario.idContrato === 0) return false;
                if (this.user.usuario.flCortesia === 'Sim') return false;

                const dias = this.diasRestantesContrato;
                return dias !== null && dias >= 0 && dias <= 45;
            },

            mensagemContratoExpirando() {
                const dias = this.diasRestantesContrato;
                if (dias === 0) return 'Seu contrato encerra hoje. Entre em contato com nossa equipe para renovação.';
                if (dias === 1) return 'Seu contrato encerra em 1 dia. Entre em contato com nossa equipe para renovação.';
                return `Seu contrato encerra em ${dias} dias. Entre em contato com nossa equipe para renovação.`;
            },
            
        },
        data: function () {
            return {
                routes: this.$router.options.routes.filter(x => x.meta != undefined && x.meta.authenticated == false),
                urlGrupo: 'https://negociospublicos.com.br/',
                msgManutencao: msgManutencao,
                urlSuporte: urlSuporte,
                msgPreparandoAmbiente: null,

                lstLink: [
                    {
                        img: '/assets/images/sollai/provisorio.png',
                        name: 'Processos Inteligentes',
                        to: '/ProcessosInteligentes',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/Workflow.png',
                        name: 'Fluxo de Trabalho',
                        to: '/ProcessosWorkflow',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/search.png',
                        name: 'Modelos Personalizados',
                        to: '/ModeloArtefatoPersonalizado',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/text.png',
                        name: 'Consulta Inteligente',
                        to: '/Consulta',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/leis.png',
                        name: 'Artefato',
                        to: '/Artefato',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/search.png',
                        name: 'Research',
                        to: '/Research',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/mortarboard.png',
                        name: 'SollAcademy',
                        to: '/SollAcademy',
                        cdIdentificador: 'SA',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/e-book.png',
                        name: 'Minhas Trilhas',
                        to: '/SollAcademyMinhasTrilhas',
                        cdIdentificador: 'SA',
                        flPossuiProduto: null,
                    },
                    {
                        img: '/assets/images/sollai/account-supervisor-outline-header.png',
                        name: 'Orientacao',
                        to: '/Orientacoes',
                        cdIdentificador: 'SO',
                        flPossuiProduto: null,
                    },
                ],
                theme: null,

            }
        },
        methods: {
            subIsActive(input) {
                if (!input?.to) return false;

                const currentPath = (this.$route.path || '').toLowerCase();
                const targetPath = input.to.toLowerCase();
                return currentPath === targetPath || currentPath.startsWith(targetPath + '/');
            },

            onLogoClick() {
                if (this.$route.name === 'Home') {
                    this.$root.$emit('reset-home');
                }
            },

            checkForm() {
                var form = document.querySelector('form')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            autoatendimento() {
                document.getElementById('blip-chat-icon').click();
            },

            scrolToDiv(id) {
                document.getElementById(id).scrollIntoView();
            },

            sair() {
                let $this = this;
                axios.get(`${urlApi}/Auth/revoke`)
                    .then(function () {
                        $this.$store.commit('setUser', null)
                        location.reload();
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            showModal(modal, tpModal) {
                this.$store.commit('setModal', { show: !modal, tpModal: tpModal })
            },

            montaLinks() {
                switch (this.$route.name) {
                    case 'Consulta':
                    case 'Artefato':
                    case 'Research':
                    case 'Chat':
                    case 'ParecerParametrizado':
                        this.lstLink = [
                            {
                                img: '/assets/images/sollai/text.png',
                                name: 'Consulta Inteligente',
                                to: '/Consulta',
                                cdIdentificador: 'SC',
                                flPossuiProduto: null,
                            },
                            {
                                img: '/assets/images/sollai/leis.png',
                                name: 'Artefato',
                                to: '/Artefato',
                                cdIdentificador: 'SC',
                                flPossuiProduto: null,
                            },
                            {
                                img: '/assets/images/sollai/search.png',
                                name: 'Research',
                                to: '/Research',
                                cdIdentificador: 'SC',
                                flPossuiProduto: null,
                            },
                            {
                                img: '/assets/images/sollai/parecerparametrizado.png',
                                name: 'Parecer Parametrizado',
                                to: '/ParecerParametrizado',
                                cdIdentificador: 'SC',
                                flPossuiProduto: null,
                            },
                        ];
                        break;

                    case 'DetalhesProcesso':
                    case 'ArtefatosGeraisStatus':
                    case 'ModeloPersonalizado':
                    case 'DetalhesWorkflow':
                    case 'ProcessoWorkflow':
                    case 'ProcessoAprovacao':
                    case 'ProcessoRevisao':
                    case 'ProcessoRevisado':
                    case 'ProcessoAssinatura':
                    case 'ProcessoInteligente':
                        this.lstLink = [
                            {
                                img: '/assets/images/sollai/provisorio.png',
                                name: 'Processos Inteligentes',
                                to: '/ProcessosInteligentes',
                                cdIdentificador: 'PI',
                                flPossuiProduto: null,
                            },
                            {
                                img: '/assets/images/sollai/Workflow.png',
                                name: 'Fluxo de Trabalho',
                                to: '/ProcessosWorkflow',
                                cdIdentificador: 'PI',
                                flPossuiProduto: null,
                            },
                            {
                                img: '/assets/images/sollai/Editor.png',
                                name: 'Modelos Personalizados',
                                to: '/ModeloPersonalizado',
                                cdIdentificador: 'PI',
                                flPossuiProduto: null,
                            }
                        ];
                        break;

                    case 'SollAcademy':
                    case 'SollAcademyAula':
                    case 'SollAcademyMinhasTrilhas':
                    case 'SollAcademyTrilhas':
                        this.lstLink = [
                            {
                                img: '/assets/images/sollai/mortarboard.png',
                                name: 'SollAcademy',
                                to: '/SollAcademy',
                                cdIdentificador: 'SA',
                                flPossuiProduto: null,
                            },
                            {
                                img: '/assets/images/sollai/e-book.png',
                                name: 'Minhas Trilhas',
                                to: '/SollAcademyMinhasTrilhas',
                                cdIdentificador: 'SA',
                                flPossuiProduto: null,
                            },
                        ];
                        break;
                    case 'Orientacoes':
                    case 'Detalheorientacao':
                        this.lstLink = [
                            {
                                img: '/assets/images/sollai/account-supervisor-outline-header.png',
                                name: 'Orientações',
                                to: '/Orientacoes',
                                cdIdentificador: 'SO',
                                flPossuiProduto: null,
                            },
                        ];
                        break;
                    case 'RegistroNecessidade':
                        this.lstLink = [
                            {
                                img: '/assets/images/sollai/icone-sollaregistro.png',
                                name: 'Registros de Necessidade',
                                to: '/RegistroNecessidade',
                                cdIdentificador: 'PI',
                                flPossuiProduto: null,
                            },
                        ];
                        break;
                    case 'RequisicaoCompra':
                    case 'ModeloFormulario':
                        this.lstLink = [
                            {
                                img: '/assets/images/sollai/icone-requisicaocompra.svg',
                                name: 'Requisições de Compras',
                                to: '/RequisicaoCompra',
                                cdIdentificador: 'PI',
                                flPossuiProduto: true,
                            },
                            {
                                img: '/assets/images/sollai/icone-modeloformulario.svg',
                                name: 'Modelos de Formulário',
                                to: '/ModeloFormulario',
                                cdIdentificador: 'PI',
                                flPossuiProduto: true,
                            },
                        ];
                        break;
                    case 'Fornecedores':
                    case 'Editais':
                    case 'BancoPenalidades':
                    case 'DetalheFornecedor':
                    case 'DetalheEdital':
                    case 'DetalhePenalidade':
                    case 'Periodicos':
                    case 'ListaPeriodicos':
                    case 'PesquisaPeriodicos':
                    case 'LeiComentada':
                    case 'Pesquisa':
                    case 'LeitorPdfFerramenta':
                    case 'Modelos':
                        this.lstLink = [
                            {
                                img: '/assets/images/sollai/fornecedores-min.png',
                                name: 'Fornecedores',
                                to: '/Fornecedores',
                                cdIdentificador: '',
                                flPossuiProduto: true,
                                class: ' invert'
                            },
                            {
                                img: '/assets/images/sollai/editais-min.png',
                                name: 'Editais',
                                to: '/Editais',
                                cdIdentificador: '',
                                flPossuiProduto: true,
                                class: ' invert'
                            },
                            {
                                img: '/assets/images/sollai/banco-min.png',
                                name: 'Banco de Penalidades',
                                to: '/BancoPenalidades',
                                cdIdentificador: '',
                                flPossuiProduto: true,
                                class: ' invert'
                            },
                            {
                                img: '/assets/images/sollai/periodicos-min.png',
                                name: 'Periódicos',
                                to: '/Periodicos',
                                cdIdentificador: '',
                                flPossuiProduto: true,
                                class: ' invert'
                            },
                            {
                                img: '/assets/images/sollai/lei-min.png',
                                name: 'Lei Comentada',
                                to: '/LeiComentada',
                                cdIdentificador: '',
                                flPossuiProduto: true,
                                class: ' invert'
                            },
                            {
                                img: '/assets/images/sollai/modelos-min.png',
                                name: 'Modelos',
                                to: '/Modelos',
                                cdIdentificador: '',
                                flPossuiProduto: true,
                                class: ' invert'
                            },
                            {
                                img: '/assets/images/sollai/icone_pesquisa_menor-min.png',
                                name: 'Pesquisa',
                                to: '/Pesquisa',
                                cdIdentificador: '',
                                flPossuiProduto: true,
                                class: ' invert'
                            },
                        ];
                        break;
                    default:
                        this.lstLink = [];
                        break;
                }
            },

            load() {
                let $this = this;
                $this.getClienteAssistente();
                $this.montaLinks();
                this.$store.commit('setInstituicao');

                axios.get(`${urlApi}/Produto/GetPermissoesProdutos`)
                    .then(res => {
                        if (res.data.success) {
                            res.data.data.forEach(item => {
                                $this.lstLink.forEach(item2 => {
                                    if (item.produto.cdIdentificador == item2.cdIdentificador) {
                                        item2.flPossuiProduto = item.flPossuiProduto;
                                    }
                                });
                            });

                            const podeVerEspecial =
                                $this.isAdmContrato == 'Sim' ||
                                $this.user?.usuarioApi?.flAdministrador ||
                                $this.user?.usuario?.idContrato == 0 ||
                                $this.user?.usuario?.dsLogin == 'aline.oliveira@negociospublicos.com.br';

                            $this.lstLink = $this.lstLink.map(link => {
                                if (link.to === '/ProcessosWorkflow') {
                                    return { ...link, flPossuiProduto: !!podeVerEspecial };
                                }
                                if (link.to === "/ModeloPersonalizado") {
                                    return { ...link, flPossuiProduto: true }
                                }
                                if (link.to === "/ModeloFormulario") {
                                    return { ...link, flPossuiProduto: !!podeVerEspecial }
                                }
                                return link;
                            });

                            $this.lstLink = $this.lstLink.filter(l => l.to !== '/Normativa');
                            $this.lstLink.push({
                                icon: `<path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0" />
<path d="M12.096 6.223A5 5 0 0 0 13 5.698V7c0 .289-.213.654-.753 1.007a4.5 4.5 0 0 1 1.753.25V4c0-1.007-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1s-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4v9c0 1.007.875 1.755 1.904 2.223C4.978 15.71 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-.813-.927Q8.378 15 8 15c-1.464 0-2.766-.27-3.682-.687C3.356 13.875 3 13.373 3 13v-1.302c.271.202.58.378.904.525C4.978 12.71 6.427 13 8 13h.027a4.6 4.6 0 0 1 0-1H8c-1.464 0-2.766-.27-3.682-.687C3.356 10.875 3 10.373 3 10V8.698c.271.202.58.378.904.525C4.978 9.71 6.427 10 8 10q.393 0 .774-.024a4.5 4.5 0 0 1 1.102-1.132C9.298 8.944 8.666 9 8 9c-1.464 0-2.766-.27-3.682-.687C3.356 7.875 3 7.373 3 7V5.698c.271.202.58.378.904.525C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777M3 4c0-.374.356-.875 1.318-1.313C5.234 2.271 6.536 2 8 2s2.766.27 3.682.687C12.644 3.125 13 3.627 13 4c0 .374-.356.875-1.318 1.313C10.766 5.729 9.464 6 8 6s-2.766-.27-3.682-.687C3.356 4.875 3 4.373 3 4" />`,
                                name: 'Normativa',
                                to: '/Normativa',
                                flPossuiProduto: true
                            });

                            $this.montaPopover();
                        }
                    })
                    .catch(res => {
                        if (res.response?.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response?.statusText || 'Erro ao carregar permissões.');
                        }
                    });
            },

            getClienteAssistente() {
                let $this = this;
                axios.get(`${urlApi}/ClienteAssistente/Get`)
                    .then(res => {
                        if (res.data.success) {
                            var clienteAssistente = res.data.data;
                            if (!clienteAssistente.flAtivo) {
                                $this.msgPreparandoAmbiente = 'error';
                            } else {
                                $this.msgPreparandoAmbiente = clienteAssistente.dsStatus;
                            }
                        }
                    })
                    .catch(res => {
                        $this.msgPreparandoAmbiente = 'error';
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            montaPopover() {
                var popovers = document.querySelectorAll(".popover");
                // Itera sobre cada elemento e remove-o
                popovers.forEach(function (popover) {
                    popover.remove();
                });


                this.$nextTick(function () {
                    var popoverTriggerList = document.querySelectorAll(
                        '[data-bs-toggle="popover"]',
                    );// eslint-disable-line no-console

                    if (popoverTriggerList.length > 0) {
                        [].slice
                            .call(popoverTriggerList)
                            .map(function (popoverTriggerEl) {
                                return new window.bootstrap.Popover(popoverTriggerEl, {
                                    trigger: "hover",
                                    boundary: "window",
                                    html: true,
                                    placement: "bottom",
                                });
                            });
                    }
                });
            },

            InitSignalR() {
                try {
                    let $this = this;

                    $this.hubConection.on("AtualizaPreparandoAmbiente", function (status) {
                        $this.msgPreparandoAmbiente = status;
                    });

                }
                catch (ex) {
                    console.log(ex);
                }
            },

        },
        mounted: function () {
            this.load();

            this.theme = localStorage.getItem('_SollAI.Tema') == "true" ? true : false;
            document.documentElement.setAttribute("data-bs-theme", (this.theme ? "dark" : "light"));
            let ej2Theme = this.theme ? "material-dark" : "material";
            const linkEj2Theme = document.getElementById("ej2-theme");
            linkEj2Theme.href = `https://cdn.syncfusion.com/ej2/31.2.2/${ej2Theme}.css`;

            // signalR
            if (this.hubConection != undefined) {
                // signalR
                this.InitSignalR();
            }
        },
        watch: {
            theme: function () {
                localStorage.setItem('_SollAI.Tema', this.theme);

                document.documentElement.setAttribute("data-bs-theme", (this.theme ? "dark" : "light"));
                let ej2Theme = this.theme ? "material-dark" : "material";
                const linkEj2Theme = document.getElementById("ej2-theme");
                linkEj2Theme.href = `https://cdn.syncfusion.com/ej2/31.2.2/${ej2Theme}.css`;
            }
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    /* ========================================
       HEADER MODERNO - ESTILOS MELHORADOS
       ======================================== */
    
    @keyframes float {
        0%, 100% {
            transform: translateY(0px);
        }
        50% {
            transform: translateY(-3px);
        }
    }

    @keyframes pulse-glow {
        0%, 100% {
            box-shadow: 0 0 0 0 rgba(31, 123, 255, 0);
        }
        50% {
            box-shadow: 0 0 20px 4px rgba(31, 123, 255, 0.3);
        }
    }

    @keyframes slideInDown {
        from {
            opacity: 0;
            transform: translateY(-5px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Logo com animação suave */
    .tyn-appbar-logo {
        .tyn-logo {
            display: block;
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.05);
                filter: drop-shadow(0 4px 12px rgba(31, 123, 255, 0.3));
            }
        }
    }

    .logo-home {
        display: block;
    }
    
    .logo-home-white {
        display: none;
    }

    [data-bs-theme=dark] .logo-home {
        display: none;
    }
    
    [data-bs-theme=dark] .logo-home-white {
        display: block;
    }

    /* Navegação com animação de entrada */
    .tyn-appbar-item {
        animation: slideInDown 0.4s ease-out backwards;
        
        @for $i from 1 through 10 {
            &:nth-child(#{$i}) {
                animation-delay: #{$i * 0.05}s;
            }
        }
    }

    /* Botões de navegação modernos */
    .tyn-appbar-link {
        position: relative;
        border-radius: 14px;
        padding: 0.65rem 0.75rem;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(31, 123, 255, 0.04);
        border: 1.5px solid rgba(31, 123, 255, 0.12);
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
        cursor: pointer;

        &::before {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            width: 0;
            height: 0;
            border-radius: 50%;
            background: radial-gradient(circle, rgba(31, 123, 255, 0.2) 0%, transparent 70%);
            transform: translate(-50%, -50%);
            transition: width 0.5s ease, height 0.5s ease;
        }

        &:hover::before {
            width: 200%;
            height: 200%;
        }

        &:hover {
            background: linear-gradient(135deg, rgba(31, 123, 255, 0.12) 0%, rgba(0, 208, 132, 0.12) 100%);
            border-color: rgba(31, 123, 255, 0.25);
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(31, 123, 255, 0.25);

            .img-icone {
                transform: scale(1.1) rotate(5deg);
                filter: drop-shadow(0 4px 8px rgba(31, 123, 255, 0.3));
            }

            svg {
                transform: scale(1.1);
                color: #1f7bff !important;
            }
        }

        &:active {
            transform: translateY(0);
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.15);
        }
    }

    /* Botão ativo com destaque forte */
    .tyn-appbar-item.active .tyn-appbar-link,
    .tyn-appbar-link.active {
        background: linear-gradient(135deg, rgba(31, 123, 255, 0.2) 0%, rgba(0, 208, 132, 0.2) 100%);
        border-color: #1f7bff;
        border-width: 2px;
        box-shadow: 0 6px 16px rgba(31, 123, 255, 0.35), 
                    inset 0 1px 3px rgba(255, 255, 255, 0.15),
                    0 0 0 3px rgba(31, 123, 255, 0.1);
        animation: pulse-glow 3s ease-in-out infinite;

        &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 50%;
            transform: translateX(-50%);
            width: 70%;
            height: 4px;
            background: linear-gradient(90deg, #1f7bff 0%, #00d084 100%);
            border-radius: 3px 3px 0 0;
            box-shadow: 0 2px 8px rgba(31, 123, 255, 0.5);
        }

        .img-icone {
            transform: scale(1.1);
            filter: drop-shadow(0 6px 16px rgba(31, 123, 255, 0.5)) brightness(1.1);
        }

        svg {
            color: #1f7bff !important;
            filter: drop-shadow(0 3px 6px rgba(31, 123, 255, 0.4));
            transform: scale(1.05);
        }
    }

    /* Ícones com sombras */
    .img-icone {
        max-width: 32px;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
    }

    [data-bs-theme=dark] .img-icone {
        filter: invert(1) drop-shadow(0 2px 8px rgba(255, 255, 255, 0.2));
    }

    svg {
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.1));
    }

    [data-bs-theme=dark] svg {
        color: white;
        filter: drop-shadow(0 2px 4px rgba(255, 255, 255, 0.1));
    }

    /* Botões no dark mode - mais claros e visíveis */
    [data-bs-theme=dark] .tyn-appbar-link {
        background: rgba(96, 165, 250, 0.12);
        border-color: rgba(96, 165, 250, 0.25);
        box-shadow: 0 2px 6px rgba(59, 130, 246, 0.15);

        &:hover {
            background: linear-gradient(135deg, rgba(96, 165, 250, 0.25) 0%, rgba(52, 211, 153, 0.25) 100%);
            border-color: rgba(96, 165, 250, 0.5);
            box-shadow: 0 6px 16px rgba(96, 165, 250, 0.4);

            .img-icone {
                filter: invert(1) drop-shadow(0 4px 12px rgba(96, 165, 250, 0.6)) brightness(1.3);
            }

            svg {
                color: #60a5fa !important;
                filter: drop-shadow(0 3px 8px rgba(96, 165, 250, 0.5)) brightness(1.2);
            }
        }
    }

    [data-bs-theme=dark] .tyn-appbar-item.active .tyn-appbar-link,
    [data-bs-theme=dark] .tyn-appbar-link.active {
        background: linear-gradient(135deg, rgba(96, 165, 250, 0.3) 0%, rgba(52, 211, 153, 0.3) 100%);
        border-color: #60a5fa;
        border-width: 2px;
        box-shadow: 0 6px 16px rgba(96, 165, 250, 0.4), 
                    inset 0 1px 3px rgba(255, 255, 255, 0.1),
                    0 0 0 3px rgba(96, 165, 250, 0.15);

        &::after {
            background: linear-gradient(90deg, #60a5fa 0%, #34d399 100%);
            box-shadow: 0 2px 8px rgba(96, 165, 250, 0.6);
        }

        .img-icone {
            filter: invert(1) drop-shadow(0 6px 16px rgba(96, 165, 250, 0.7)) brightness(1.4);
        }

        svg {
            color: #60a5fa !important;
            filter: drop-shadow(0 3px 8px rgba(96, 165, 250, 0.6)) brightness(1.3);
        }
    }

    /* Avatar do usuário com efeito */
    .tyn-media {
        transition: all 0.3s ease;
        border: 2px solid transparent;

        &::after {
            content: '';
            position: absolute;
            inset: -2px;
            border-radius: inherit;
            background: linear-gradient(135deg, #1f7bff, #00d084);
            z-index: -1;
            opacity: 0;
            transition: opacity 0.3s ease;
        }

        &:hover {
            transform: scale(1.08);
            box-shadow: 0 6px 20px rgba(31, 123, 255, 0.3);

            &::after {
                opacity: 1;
            }
        }

        img {
            position: relative;
            z-index: 1;
            border-radius: inherit;
        }
    }

    /* Dropdown melhorado */
    .dropdown-toggle {
        transition: all 0.3s ease;

        &:hover {
            transform: translateY(-2px);
        }

        &::after {
            display: none;
        }
    }

    .dropdown-menu {
        z-index: 1001;
        border-radius: 16px;
        border: 2px solid rgba(31, 123, 255, 0.1);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15);
        padding: 0.75rem;
        backdrop-filter: blur(10px);
        background: rgba(255, 255, 255, 0.98);
        /* Transição suave sem animação para evitar conflitos */
        transition: opacity 0.15s ease-out;
        animation: none !important;
        /* Scroll quando necessário */
        max-height: calc(100vh - 120px);
        overflow-y: auto;
        overflow-x: hidden;
        
        /* Estilização da barra de scroll */
        &::-webkit-scrollbar {
            width: 8px;
        }
        
        &::-webkit-scrollbar-track {
            background: rgba(31, 123, 255, 0.05);
            border-radius: 10px;
        }
        
        &::-webkit-scrollbar-thumb {
            background: rgba(31, 123, 255, 0.3);
            border-radius: 10px;
            transition: background 0.3s ease;
            
            &:hover {
                background: rgba(31, 123, 255, 0.5);
            }
        }

        .dropdown-gap {
            padding: 0.75rem;
            border-radius: 12px;
            margin-bottom: 0.5rem;
            transition: all 0.3s ease;

            &:hover {
                background: rgba(31, 123, 255, 0.05);
            }
        }

        .tyn-media-group {
            .name {
                font-weight: 600;
                color: #2d3748;
                transition: color 0.3s ease;
            }

            .indicator {
                transition: all 0.3s ease;
                
                &.varified svg {
                    color: #00d084;
                    filter: drop-shadow(0 2px 4px rgba(0, 208, 132, 0.3));
                }
            }
        }

        /* Switch de tema */
        .form-check-input {
            cursor: pointer;
            width: 3rem;
            height: 1.5rem;
            border-radius: 2rem;
            background-color: #cbd5e0;
            border: 2px solid #cbd5e0;
            transition: all 0.3s ease;
            position: relative;

            &::before {
                content: '';
                position: absolute;
                top: 50%;
                left: 2px;
                transform: translateY(-50%);
                width: 1.1rem;
                height: 1.1rem;
                background: white;
                border-radius: 50%;
                transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
            }

            &:checked {
                background: linear-gradient(135deg, #1f7bff 0%, #00d084 100%);
                border-color: #1f7bff;

                &::before {
                    left: calc(100% - 1.1rem - 2px);
                    box-shadow: 0 2px 8px rgba(31, 123, 255, 0.4);
                }
            }

            &:hover {
                box-shadow: 0 0 0 4px rgba(31, 123, 255, 0.1);
            }
        }
    }

    [data-bs-theme=dark] .dropdown-menu {
        background: rgba(30, 41, 59, 0.98);
        border-color: rgba(31, 123, 255, 0.2);

        .dropdown-gap:hover {
            background: rgba(31, 123, 255, 0.1);
        }

        .name {
            color: #cbd5e1;
        }
        
        /* Estilização da barra de scroll no dark mode */
        &::-webkit-scrollbar-track {
            background: rgba(96, 165, 250, 0.1);
        }
        
        &::-webkit-scrollbar-thumb {
            background: rgba(96, 165, 250, 0.4);
            
            &:hover {
                background: rgba(96, 165, 250, 0.6);
            }
        }
    }

    /* Links do dropdown */
    .tyn-list-links {
        li {
            margin-bottom: 0.25rem;

            &:last-child {
                margin-bottom: 0;
            }
        }

        a, router-link {
            display: flex;
            align-items: center;
            gap: 0.75rem;
            padding: 0.75rem 1rem;
            border-radius: 10px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            color: #4a5568;
            text-decoration: none;
            font-weight: 500;
            position: relative;
            overflow: hidden;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                bottom: 0;
                width: 0;
                background: linear-gradient(90deg, rgba(31, 123, 255, 0.15) 0%, transparent 100%);
                transition: width 0.3s ease;
            }

            svg, i {
                transition: all 0.3s ease;
                color: #6c757d;
                flex-shrink: 0;
            }

            &:hover {
                background: linear-gradient(135deg, rgba(31, 123, 255, 0.08) 0%, rgba(0, 208, 132, 0.08) 100%);
                color: #1f7bff;
                transform: translateX(4px);
                box-shadow: 0 2px 8px rgba(31, 123, 255, 0.15);

                &::before {
                    width: 100%;
                }

                svg, i {
                    color: #1f7bff;
                    transform: scale(1.1);
                }
            }

            &:active {
                transform: translateX(2px);
            }
        }
    }

    [data-bs-theme=dark] .tyn-list-links a,
    [data-bs-theme=dark] .tyn-list-links router-link {
        color: #cbd5e1;

        svg, i {
            color: #94a3b8;
        }

        &:hover {
            color: #60a5fa;
            background: linear-gradient(135deg, rgba(59, 130, 246, 0.1) 0%, rgba(16, 185, 129, 0.1) 100%);

            svg, i {
                color: #60a5fa;
            }
        }
    }

    /* Divider */
    .dropdown-divider {
        margin: 0.75rem 0;
        border-top: 1px solid rgba(31, 123, 255, 0.1);
        opacity: 1;
    }

    [data-bs-theme=dark] .dropdown-divider {
        border-top-color: rgba(59, 130, 246, 0.2);
    }

    /* Mensagem de manutenção */
    .msg-manutencao {
        color: #4a5568;
        font-size: 0.875rem;
        line-height: 1.6;
        padding: 0.5rem 1rem;
        background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%);
        border-radius: 12px;
        border-left: 4px solid #ffc107;
        animation: float 3s ease-in-out infinite;
    }

    [data-bs-theme=dark] .msg-manutencao {
        color: #cbd5e1;
        background: linear-gradient(135deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 152, 0, 0.15) 100%);
    }

    /* Mensagem de ambiente criado */
    .msg-ambiente-warning {
        color: #4a5568;
        font-size: 0.875rem;
        line-height: 1.6;
        padding: 0.5rem 1rem;
        background: linear-gradient(135deg, rgba(255, 193, 7, 0.1) 0%, rgba(255, 152, 0, 0.1) 100%);
        border-radius: 12px;
        border-left: 4px solid #ffc107;
        animation: float 3s ease-in-out infinite;
    }

    [data-bs-theme=dark] .msg-ambiente-warning {
        color: #cbd5e1;
        background: linear-gradient(135deg, rgba(255, 193, 7, 0.15) 0%, rgba(255, 152, 0, 0.15) 100%);
    }

    .msg-ambiente-danger {
        color: #4a5568;
        font-size: 0.875rem;
        line-height: 1.6;
        padding: 0.5rem 1rem;
        background: linear-gradient(135deg, rgba(255, 0, 0, 0.15) 0%, rgba(255, 0, 0, 0.15) 100%);
        border-radius: 12px;
        border-left: 4px solid #58151c;
        animation: float 3s ease-in-out infinite;
    }

    [data-bs-theme=dark] .msg-ambiente-danger {
        color: #cbd5e1;
        background: linear-gradient(135deg, rgba(255, 0, 7, 0.15) 0%, rgba(255, 0, 0, 0.15) 100%);
    }

    /* Alerta de vencimento do contrato */
    .msg-contrato-expirando {
        color: #92400e;
        font-size: 0.875rem;
        line-height: 1.5;
        padding: 0.45rem 0.9rem;
        background: linear-gradient(135deg, rgba(245, 158, 11, 0.14) 0%, rgba(251, 191, 36, 0.08) 100%);
        border-radius: 10px;
        border: 1px solid rgba(245, 158, 11, 0.35);
        max-width: 420px;
    }

    [data-bs-theme=dark] .msg-contrato-expirando {
        color: #fcd34d;
        background: linear-gradient(135deg, rgba(245, 158, 11, 0.18) 0%, rgba(251, 191, 36, 0.1) 100%);
        border-color: rgba(251, 191, 36, 0.4);
    }


    /* Responsividade */
    @media (max-width: 991px) {
        .tyn-appbar-link {
            padding: 0.55rem 0.65rem;
            border-radius: 12px;
        }

        .img-icone {
            max-width: 28px;
        }

        .txt-p {
            font-size: 0.8rem;
            padding: 0.4rem 0.75rem;
        }
        
        .dropdown-menu {
            max-height: calc(100vh - 100px);
        }
    }

    @media (max-width: 767px) {
        .tyn-appbar-link {
            padding: 0.5rem 0.6rem;
            border-radius: 10px;
        }

        .img-icone {
            max-width: 26px;
        }

        .dropdown-menu {
            border-radius: 14px;
            padding: 0.5rem;
            max-height: calc(100vh - 80px);
        }

        .tyn-list-links a,
        .tyn-list-links router-link {
            padding: 0.65rem 0.85rem;
            font-size: 0.9rem;
        }
    }

    .invert {
        filter: invert(80%);
    }

    [data-bs-theme="dark"] .invert {
        filter: none;
    }

</style>

